/**
 * C2 公共资产分类词表(与 api PresetAvatarCatalog.category / PresetVoiceCatalog.usage 逐字对齐)。
 * 中文名单一源在此 —— 形象库/声音库的筛选 chips 都取这里,不各写各的(platformLabel 范式)。
 */

export const AVATAR_CATEGORY_LABEL: Record<string, string> = {
  lecturer: "讲师",
  business: "商务",
  retail: "门店",
  medical: "医疗",
  livestream: "直播",
};

export const VOICE_USAGE_LABEL: Record<string, string> = {
  broadcast: "播报",
  social: "种草",
  explain: "讲解",
  emotion: "情感",
  cartoon: "卡通",
};

/** 取一组资产里真实出现过的分类(顺序按词表);全都没分类 → 空数组(调用方不渲染筛选条)。 */
export function presentCategories<T extends { category?: string | null }>(
  items: T[],
  labels: Record<string, string> = AVATAR_CATEGORY_LABEL
): Array<{ key: string; label: string }> {
  const seen = new Set(items.map((i) => i.category).filter(Boolean) as string[]);
  return Object.keys(labels)
    .filter((k) => seen.has(k))
    .map((k) => ({ key: k, label: labels[k] }));
}

/** 音色用途版(字段名是 usage 不是 category)。 */
export function presentUsages<T extends { usage?: string | null }>(
  items: T[]
): Array<{ key: string; label: string }> {
  const seen = new Set(items.map((i) => i.usage).filter(Boolean) as string[]);
  return Object.keys(VOICE_USAGE_LABEL)
    .filter((k) => seen.has(k))
    .map((k) => ({ key: k, label: VOICE_USAGE_LABEL[k] }));
}
